import themeConfig from "../../../configs/themeConfig"

const customizerReducer = (state = themeConfig, action) => {
  switch (action.type) {
    case "CHANGE_MODE":
      return { ...state, theme: action.mode }
    case "CUSTOMIZER_STATE":
      return { ...state, customizerState: action.value }
    case "DISABLE_CUSTOMIZER":
      return { ...state, disableCustomizer: action.value }
    case "POLL_CUSTOMIZER_STATE":
      return { ...state, pollcustomizer: action.value }
    case "OFF_CUSTOMIZER":
      return { ...state, pollcustomizer: action.value, customizerState: action.value }
    case "CHANGE_AGENDA_VIDEO":
      return { ...state, agendavideo: action.value }
    case "HOME_TOUR":
      return { ...state, hometour: action.value }
    case "HOME_VIDEO":
      return { ...state, homevideo: action.value }
    case "COLLAPSE_SIDEBAR":
      return { ...state, sidebarCollapsed: action.value }
    case "CHANGE_NAVBAR_COLOR":
      return { ...state, navbarColor: action.color }
    case "CHANGE_NAVBAR_TYPE":
      return { ...state, navbarType: action.style }
    case "CHANGE_FOOTER_TYPE":
      return { ...state, footerType: action.style }
    case "CHANGE_MENU_COLOR":
      return { ...state, menuTheme: action.style }
    case "HIDE_SCROLL_TO_TOP":
      return { ...state, hideScrollToTop: action.value }
    default:
      return state
  }
}

export default customizerReducer
